package org.braunequip.web.components.forms

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.functions.min
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaX
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.browser.document
import org.braunequip.web.components.models.ContactsDTO
import org.braunequip.web.components.widgets.ConfirmModal
import org.braunequip.web.util.Constants.FONT_FAMILY
import org.braunequip.web.util.Constants.FONT_FAMILY2
import org.braunequip.web.util.InputIDs
import org.braunequip.web.util.Theme
import org.braunequip.web.util.formatDate
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.TextArea
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.HTMLTextAreaElement

@Composable
fun AdminContactForm(
    toUpdateContact: ContactsDTO? = null,
    onSubmit: (ContactsDTO) -> Unit,
    onDismiss: () -> Unit
) {
    var showConfirmModal by remember { mutableStateOf(false) }
    var errorText by remember { mutableStateOf(" ") }
    var quoteFormState by remember(toUpdateContact) {
        mutableStateOf(
            toUpdateContact?.copy() ?: ContactsDTO()
        )
    }

    LaunchedEffect(Unit) {
        //Necessary for loading default value, and having it still be editable.
        val quoteFormTextArea = (document.getElementById(InputIDs.QuoteForm.description) as HTMLTextAreaElement)
        quoteFormTextArea.value = quoteFormState.message
    }

    Box(
        modifier = Modifier
            .width(100.vw)
            .height(100.vh)
            .position(Position.Absolute)
            .top(0.px)
            .left(0.px)
            .zIndex(19),
        contentAlignment = Alignment.TopCenter
    ) {
        Column(
            modifier = Modifier
                .backgroundColor(Colors.White)
                .borderRadius(20.px)
                .margin(top = 4.cssRem)
                .padding(1.cssRem)
                .zIndex(20)
                .width(min(500.px, 100.percent - 2.cssRem)),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Top
        ) {
            Row(
                modifier = Modifier
                    .fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {

                SpanText(
                    text = "ID: ${quoteFormState.id}",
                    modifier = Modifier
                        .fontSize(1.cssRem)
                        .fontFamily(FONT_FAMILY2)
                )


                FaX(
                    modifier = Modifier
                        .cursor(Cursor.Pointer)
                        .onClick {
                            onDismiss()
                        }
                        .color(Colors.Grey)
                )
            }

            /* Specific Form Rows Here */
            Input(
                type = InputType.Text,
                attrs = Modifier
                    .id(InputIDs.QuoteForm.name)
                    .fillMaxWidth()
                    .height(54.px)
                    .margin(topBottom = 12.px)
                    .padding(leftRight = 20.px)
                    .backgroundColor(Theme.LightGray.rgb)
                    .borderRadius(r = 4.px)
                    .border(
                        width = 2.px,
                        style = LineStyle.Solid,
                        color = Colors.Black
                    )
                    .fontFamily(FONT_FAMILY)
                    .fontSize(16.px)
                    .toAttrs {
                        attr("placeholder", "Name*")
                        attr("value", quoteFormState.name) // Set value from DTO
                    }
            )

            Input(
                type = InputType.Text,
                attrs = Modifier
                    .id(InputIDs.QuoteForm.email)
                    .fillMaxWidth()
                    .height(54.px)
                    .margin(topBottom = 12.px)
                    .padding(leftRight = 20.px)
                    .backgroundColor(Theme.LightGray.rgb)
                    .borderRadius(r = 4.px)
                    .border(
                        width = 2.px,
                        style = LineStyle.Solid,
                        color = Colors.Black
                    )
                    .fontFamily(FONT_FAMILY)
                    .fontSize(16.px)
                    .toAttrs {
                        attr("placeholder", "Email*")
                        attr("value", quoteFormState.email) // Set value from DTO
                    }
            )

            Input(
                type = InputType.Text,
                attrs = Modifier
                    .id(InputIDs.QuoteForm.phone)
                    .fillMaxWidth()
                    .height(54.px)
                    .margin(topBottom = 12.px)
                    .padding(leftRight = 20.px)
                    .backgroundColor(Theme.LightGray.rgb)
                    .borderRadius(r = 4.px)
                    .border(
                        width = 2.px,
                        style = LineStyle.Solid,
                        color = Colors.Black
                    )
                    .fontFamily(FONT_FAMILY2)
                    .fontSize(16.px)
                    .toAttrs {
                        attr("placeholder", "Phone Number*")
                        attr("value", quoteFormState.phone) // Set value from DTO
                    }
            )

            TextArea(
                attrs = Modifier
                    .id(InputIDs.QuoteForm.description)
                    .fillMaxWidth()
                    .height(175.px)
                    .maxHeight(400.px)
                    .margin(top = 8.px)
                    .padding(all = 20.px)
                    .backgroundColor(Theme.LightGray.rgb)
                    .borderRadius(4.px)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(16.px)
                    .border(
                        width = 2.px,
                        style = LineStyle.Solid,
                        color = Colors.Black
                    )
                    .resize(Resize.None)
                    .toAttrs{
                        attr("placeholder", "Brief Description")
                        onInput { event ->
                            quoteFormState.message = event.value
                        }
                    }
            )

            Row(
                modifier = Modifier
                    .fillMaxWidth(),
                horizontalArrangement = Arrangement.Start,
                verticalAlignment = Alignment.CenterVertically
            ) {
                SpanText(
                    text = "Contact From: ${quoteFormState.where}",
                    modifier = Modifier
                        .margin(topBottom = 12.px)
                        .fontSize(.75.cssRem)
                        .fontFamily(FONT_FAMILY2)
                )
            }

            Row(
                modifier = Modifier
                    .fillMaxWidth(),
                horizontalArrangement = Arrangement.Start,
                verticalAlignment = Alignment.CenterVertically
            ) {

                SpanText(
                    text = "Created: ${quoteFormState.createdAt?.let { formatDate(it) }}",
                    modifier = Modifier
                        .fontSize(.75.cssRem)
                        .fontFamily(FONT_FAMILY2)
                )
            }

            SpanText(
                modifier = Modifier
                    .width(350.px)
                    .margin(top = 1.cssRem)
                    .fontFamily(FONT_FAMILY2)
                    .color(Colors.Black)
                    .textAlign(TextAlign.Center),
                text = errorText
            )


            SubmitButton(
                text = "SUBMIT",
                onClick = {
                    quoteFormState = quoteFormState.copy(
                        name = (document.getElementById(InputIDs.QuoteForm.name) as HTMLInputElement).value,
                        email = (document.getElementById(InputIDs.QuoteForm.email) as HTMLInputElement).value,
                        phone = (document.getElementById(InputIDs.QuoteForm.phone) as HTMLInputElement).value,
                        message = (document.getElementById(InputIDs.QuoteForm.description) as HTMLTextAreaElement).value,
                        where = "NEED QUOTE FORM"
                    )

                    if (
                        quoteFormState.name.isNotEmpty() &&
                        quoteFormState.email.isNotEmpty() &&
                        quoteFormState.phone.isNotEmpty()
                    ) {
                        errorText = " "
                        showConfirmModal = true
                    } else {
                        errorText = "Please fill out all required fields."
                    }

                }
            )

            if (showConfirmModal) {
                ConfirmModal(
                    actionText = "Update Contact",
                    onConfirm = {
                        errorText = "Submitted!"
                        onSubmit(quoteFormState)
                        showConfirmModal = false
                    },
                    onDismiss = {
                        showConfirmModal = false
                    }
                )
            }
        }

        Box(
            modifier = Modifier
                .fillMaxSize()
                .backgroundColor(Theme.DarkerGray.rgb)
                .position(Position.Fixed)
                .padding(top = 5.cssRem)
                .onClick {
                    onDismiss()
                }
                .zIndex(19),
            contentAlignment = Alignment.TopCenter
        )
    }
}